import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { industryCards } from '../data/content';

const { FiArrowDown } = FiIcons;

export default function IndustryGrid() {
  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const logoUrl = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/7ddd4e67fb490c42fb4d56deed5c8910.png";

  return (
    <section className="bg-white py-24 md:py-32 relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-sage-light blur-3xl opacity-60"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-sage-light blur-3xl opacity-60"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <div className="text-center mb-20 flex flex-col items-center">
          <img src={logoUrl} alt="Sunset Swipe" className="h-40 md:h-48 mb-8 object-contain transition-transform duration-500 hover:scale-105" />
          <p className="text-xl md:text-2xl text-deepNavy-light max-w-2xl mx-auto leading-relaxed font-light">
            Specialized payment solutions for every industry. Click your sector to explore tailored services.
          </p>
          <div className="flex items-center justify-center gap-2 mt-8 text-mutedBlue text-sm font-medium animate-bounce">
            <SafeIcon icon={FiArrowDown} className="w-5 h-5" />
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {industryCards.map(card => {
            const IconComp = FiIcons[card.icon];
            return (
              <button 
                key={card.id} 
                onClick={() => handleClick(card.id)}
                className="group flex flex-col items-center justify-center gap-4 p-8 bg-white border border-gray-100 rounded-3xl shadow-apple transition-all duration-300 hover:-translate-y-1 hover:shadow-apple-hover hover:border-sage text-center cursor-pointer"
              >
                <div className="w-16 h-16 rounded-2xl bg-sage-lightest group-hover:bg-sage-light flex items-center justify-center transition-colors duration-300">
                  {IconComp && (
                    <SafeIcon icon={IconComp} className="w-8 h-8 text-mutedBlue group-hover:text-sage transition-colors duration-300" />
                  )}
                </div>
                <span className="text-base font-semibold text-deepNavy group-hover:text-sage-alt leading-tight transition-colors duration-300">
                  {card.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}